import React, { useEffect, useRef } from 'react';
import treeBg from '../videos/zohtek-tree-loop-20s-compressed.mp4';

const scrimStyles = [
  { background: 'linear-gradient(102deg, rgba(5,7,10,0.94) 0%, rgba(5,7,10,0.78) 30%, rgba(5,7,10,0.28) 56%, rgba(5,7,10,0) 78%)' },
  { background: 'linear-gradient(0deg, rgba(5,7,10,0.78) 0%, rgba(5,7,10,0) 26%)' },
  { background: 'linear-gradient(180deg, rgba(5,7,10,0.88) 0%, rgba(5,7,10,0.4) 9%, rgba(5,7,10,0) 18%)' },
];

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches && videoRef.current) {
      videoRef.current.pause();
    }
  }, []);

  return (
  <section
    id="top"
    style={{
      position: 'relative',
      width: '100%',
      minHeight: '100vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <video
        ref={videoRef}
        src={treeBg}
        autoPlay
        muted
        loop
        playsInline
        disablePictureInPicture
        disableRemotePlayback
        controlsList="nodownload nofullscreen noremoteplayback"
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
          pointerEvents: 'none',
          filter: 'brightness(1.2) saturate(1.35) contrast(1.05)',
        }}
      />
    {scrimStyles.map((s, i) => (
      <div
        key={i}
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          pointerEvents: 'none',
          ...s,
        }}
      />
    ))}

    <main
      className="zk-hero-main"
      style={{
        position: 'relative',
        zIndex: 3,
        flex: 1,
        display: 'flex',
        alignItems: 'flex-start',
        paddingTop: '140px',
      }}
    >
      <div className="zk-hero-pad" style={{ maxWidth: '820px', padding: '0 56px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            marginBottom: '30px',
            animation: 'zk-fade-up 0.7s ease both',
          }}
        >
          <span
            style={{
              display: 'block',
              width: '22px',
              height: '2px',
              background: '#ff3ea5',
              boxShadow: '0 0 10px #ff3ea5',
              transformOrigin: 'left',
              animation: 'zk-bar-pulse 3.4s ease-in-out infinite',
            }}
          />
          <span
            style={{
              fontFamily: 'var(--zk-mono)',
              fontSize: '12px',
              letterSpacing: '0.34em',
              color: 'rgba(232,238,240,0.6)',
              textTransform: 'uppercase',
            }}
          >
            Business · Data · AI · Cloud
          </span>
        </div>

        <h1
          style={{
            margin: 0,
            fontWeight: 600,
            fontSize: 'clamp(46px, 6.6vw, 96px)',
            lineHeight: 0.96,
            letterSpacing: '-0.025em',
            animation: 'zk-fade-up 0.8s ease 0.08s both',
          }}
        >
          <span style={{ display: 'block' }}>Make your</span>
          <span
            style={{
              display: 'block',
              color: '#ff3ea5',
              textShadow: '0 0 46px rgba(255,62,165,0.42)',
            }}
          >
            knowledge
          </span>
          <span style={{ display: 'block' }}>work.</span>
        </h1>

        <div
          style={{
            margin: '26px 0 28px',
            fontFamily: 'var(--zk-mono)',
            fontSize: '13px',
            letterSpacing: '0.32em',
            textTransform: 'uppercase',
            color: '#38e0ff',
            opacity: 0.92,
            animation: 'zk-fade-up 0.8s ease 0.16s both',
          }}
        >
          Innovate · Empower · Evolve
        </div>

        <p
          style={{
            maxWidth: '560px',
            margin: '0 0 38px',
            fontSize: '18px',
            lineHeight: 1.66,
            color: 'rgba(232,238,240,0.74)',
            textWrap: 'pretty',
            animation: 'zk-fade-up 0.8s ease 0.24s both',
          }}
        >
          Zohtek is a Melbourne-based data and AI consulting practice. We work across business analysis, data foundations, and applied machine learning, turning scattered systems and unclear requirements into something structured, measurable, and built to last. Australian-based, your data handled here, delivered on Azure and AWS.
        </p>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            alignItems: 'center',
            animation: 'zk-fade-up 0.8s ease 0.32s both',
          }}
        >
          <a href="#services" className="zk-hero-cta-pink">
            [ EXPLORE_SERVICES ] <span style={{ fontSize: '15px' }}>→</span>
          </a>
          <a href="#rates" className="zk-hero-cta-cyan">
            [ VIEW_RATES ] <span style={{ fontSize: '15px' }}>→</span>
          </a>
        </div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '14px',
            marginTop: '42px',
            fontFamily: 'var(--zk-mono)',
            fontSize: '11px',
            letterSpacing: '0.08em',
            color: 'rgba(232,238,240,0.42)',
            animation: 'zk-fade-up 0.8s ease 0.4s both',
          }}
        >
          <span>ABN 34 641 696 595</span>
          <span style={{ color: '#ff3ea5', opacity: 0.55 }}>/</span>
          <span>AZURE · AWS CERTIFIED</span>
          <span style={{ color: '#ff3ea5', opacity: 0.55 }}>/</span>
          <span>MELBOURNE, AU</span>
        </div>
      </div>
    </main>

    <a
      href="#trust"
      aria-label="Scroll to next section"
      className="zk-hero-scroll"
      style={{
        position: 'absolute',
        left: '50%',
        bottom: '26px',
        transform: 'translateX(-50%)',
        zIndex: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        textDecoration: 'none',
        cursor: 'pointer',
        transition: 'opacity 0.25s',
      }}
    >
      <span
        style={{
          fontFamily: 'var(--zk-mono)',
          fontSize: '9.5px',
          letterSpacing: '0.34em',
          color: 'rgba(232,238,240,0.4)',
        }}
      >
        SCROLL
      </span>
      <div
        style={{
          position: 'relative',
          width: '1px',
          height: '34px',
          background: 'rgba(232,238,240,0.14)',
          overflow: 'hidden',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '1px',
            height: '8px',
            background: '#38e0ff',
            boxShadow: '0 0 8px #38e0ff',
            animation: 'zk-scroll-bob 2s ease-in-out infinite',
          }}
        />
      </div>
    </a>
  </section>
  );
};

export default Hero;
